import { fade } from "@material-ui/core/styles/colorManipulator";

export const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  style: {
    display: "none",
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  body: {
    fontSize: "14px",
    fontWeight: "400",
    padding: 0,
  },
  icon: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
  },
  iconWrap: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
    padding: "4px",
  },
  title: {
    display: "inline-block",
    fontSize: 34,
    fontWeight: 500,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.8)",
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    // backgroundColor: '#eaeaea'
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
  },
});
